import { useState, useEffect, RefObject } from 'react';
import { AFrameScene, SceneInteractionHook, ActiveScene } from '../types';

export const useSceneInteraction = (
  sceneRef: RefObject<AFrameScene | null>,
  secondSceneRef: RefObject<AFrameScene | null>,
  isSplitView: boolean
): SceneInteractionHook => {
  const [activeScene, setActiveScene] = useState<ActiveScene>('main');

  // Track which scene is being interacted with
  useEffect(() => {
    if (!isSplitView) return;

    const mainScene = sceneRef.current;
    const secondScene = secondSceneRef.current;
    
    if (!mainScene || !secondScene) return;

    const handleMainInteraction = (): void => setActiveScene('main');
    const handleSecondInteraction = (): void => setActiveScene('second');

    // Get canvas elements
    const mainCanvas = mainScene.canvas || mainScene;
    const secondCanvas = secondScene.canvas || secondScene;

    // Add interaction listeners for main scene
    mainCanvas.addEventListener('mousedown', handleMainInteraction);
    mainCanvas.addEventListener('touchstart', handleMainInteraction);
    mainCanvas.addEventListener('wheel', handleMainInteraction);

    // Add interaction listeners for second scene  
    secondCanvas.addEventListener('mousedown', handleSecondInteraction);
    secondCanvas.addEventListener('touchstart', handleSecondInteraction);
    secondCanvas.addEventListener('wheel', handleSecondInteraction);

    return () => {
      // Cleanup main scene listeners
      mainCanvas.removeEventListener('mousedown', handleMainInteraction);
      mainCanvas.removeEventListener('touchstart', handleMainInteraction);
      mainCanvas.removeEventListener('wheel', handleMainInteraction);

      // Cleanup second scene listeners
      secondCanvas.removeEventListener('mousedown', handleSecondInteraction);
      secondCanvas.removeEventListener('touchstart', handleSecondInteraction);
      secondCanvas.removeEventListener('wheel', handleSecondInteraction);
    };
  }, [isSplitView, sceneRef, secondSceneRef]);

  return {
    activeScene,
    setActiveScene
  };
};
